import { actions } from "./action-list";

export function setTokenExpired(value) {
  return {
    type: actions.TOKEN_EXPIRE,
    value,
  };
}
export function updateUserAuthorities(value) {
  return {
    type: actions.UPDATE_AUTHORITIES,
    value,
  };
}

export function menuType(value) {
  return {
    type: actions.MENU_TYPE,
    value,
  };
}

export function updateUser(value) {
  return {
    type: actions.UPDATE_USER,
    value,
  };
}

export function logoutUser(value) {
  return {
    type: actions.LOG_OUT,
    value,
  };
}
